export default __webpack_public_path__ + "static/media/layout-speaker.b55df339.png";